<template>
  <div class="p5-sketch"></div>
</template>

<script>
import p5 from "p5"; // eslint-disable-line
export default {
  name: "P5",
  props: ["sketch", "params"],

  data: function () {
    return {
      myp5: {},
    };
  },

  mounted() {
    this.$nextTick(() => (this.myp5 = new p5(this.sketch(this), this.$el)));
  },

  watch: {
    params: {
      handler: function (val, oldVal) {
        if (this.myp5.dataChanged) {
          this.myp5.dataChanged(val, oldVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
